export default "__VITE_ASSET__Cf0kmqo0__"